module.exports = __webpack_public_path__ + "static/media/user1.d0621eb3.jpg";